import '@STYLE/header.scss';

// import Image from 'next/image';
import Link from 'next/link';
import Script from 'next/script';

export default function Header() {
  return (
    <header id='headerContainer' className='header'>
      <h1 className='blind'>헤더영역 시작</h1>
      <div className='header__inner'>
        <div className='header__inner__contentBox'>
          <div className='logoBox'>
            <h2 className='mainLogo'>
              <Link href='/' className='header__logo'>
                I-ONE PAYMENT
              </Link>
            </h2>
          </div>
          <nav id='nav' className='nav'>
            <ul className='nav__list'>
              <li>
                <Link href='/#introCompany' className='gnbText'>
                  회사소개
                </Link>
              </li>
              <li>
                <Link href='/#serviceCompany' className='gnbText'>
                  서비스소개
                </Link>
              </li>
              <li>
                <Link href='/#gallery' className='gnbText'>
                  서비스신청
                </Link>
              </li>
              <li>
                <Link href='/#contactSection' className='gnbText'>
                  고객지원
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
          console.log('document', document)
            document.addEventListener('scroll', () => {
            const header = document.querySelector('.header');
            console.log(window.scrollY, window.scrollY > 80)
            if (window.scrollY > 80) {
              header.classList.add('scrolled');
            } else {
              header.classList.remove('scrolled');
            }
        });
        `,
        }}
      ></Script>
    </header>
  );
}
